import styled from '@emotion/styled';
import { Card } from 'antd';

const StyledCard = styled(Card)`
  .ant-card-head-title,
  .ant-card-extra {
    padding: 10px;
  }
`;
export function SpSubItem(props) {
  const { children, extra, ...cardProps } = props;

  return (
    <StyledCard
      headStyle={{ minHeight: 30 }}
      {...cardProps}
      style={{ ...cardProps.style, padding: 0, borderColor: '#000000', backgroundColor: '#161b26', marginBottom: 10 }}
      bodyStyle={{
        padding: 10,
      }}
      extra={<span style={{ color: '#FFFFFF' }}>{extra}</span>}
    >
      {children}
    </StyledCard>
  );
}
